import { CheckCircle2 } from "lucide-react";

export const VendorSuccess = ({ result, onReset }) => (
  <div className="hx-success hx-fade" role="status" data-testid="vendor-success">
    <CheckCircle2 size={36} strokeWidth={1.5} color="#5A776F" />
    <h2>Thank you, your pricing review was submitted.</h2>
    <p className="hx-muted">Please keep this reference for your records.</p>
    <div className="hx-success__id" data-testid="vendor-success-submission-id">{result.submission_id}</div>
    <div>
      <button type="button" className="hx-btn hx-btn--ghost" onClick={onReset} data-testid="vendor-submit-another-button">
        Start a new form
      </button>
    </div>
  </div>
);
